<template>
  <layout-default-appbar :backTo="rota">
    Unidades
  </layout-default-appbar>
</template>

<script>
import LayoutDefaultAppbar from '@/layouts/default/AppBar.vue';
import { ROUTE_ORDEM_CARREGAMENTO } from '@/constants/ROUTES';

export default {
  name: 'ViewFrotaAppBar',

  components: {
    LayoutDefaultAppbar,
  },

  data() {
    return {
      rota: ROUTE_ORDEM_CARREGAMENTO,
    }
  },

};
</script>
